import { useTranslation } from "react-i18next";
import PromoManager from "./PromoManager";

export default function HotelConventions() {
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";
  return (
    <PromoManager
      promoType="hotel"
      tag={isEn ? "Partnerships" : "Partnership"}
      title={isEn ? "Hotel Conventions" : "Convenzioni Hotel"}
      addLabel={isEn ? "New convention" : "Nuova convenzione"}
      showHotelField={true}
    />
  );
}
